import './ConfidenceScoreCard.scss';

import React from 'react';
import { connect } from 'react-redux';

import Content, { contentConverter } from 'services/Content';
import BaseCard from 'components/shared/Card/BaseCard';
import ConfidenceMeterGroup from 'components/shared/ConfidenceScore/ConfidenceMeterGroup';
import ConfidenceScoreModal from 'components/shared/ConfidenceScore/ConfidenceScoreModal';
import { hasReceivedMonteCarloConfidenceScores } from 'state/requests/RequestStatusSelectors';
import {
  getMonteCarloConfidenceScoreTargets,
  getMonteCarloConfidenceScoreTargetText
} from 'state/account/ConfidenceScoresSelectors';
import { getCustomerWebView } from 'state/customer/CustomerSelectors';
import { planningDetailsUrl } from 'services/Externals';

export const ABOVE_CONFIDENCE_ZONE = 'Above Confidence Zone';
export const IN_CONFIDENCE_ZONE = 'In Confidence Zone';
export const BELOW_CONFIDENCE_ZONE = 'Below Confidence Zone';

const Subtext = ({ targetText, targets }) => {
  const { targetRangeLow, targetRangeHigh, probabilityOfSuccess } = targets;
  let copy = '';

  if (
    targetText === ABOVE_CONFIDENCE_ZONE &&
    probabilityOfSuccess > targetRangeHigh
  ) {
    copy = Content.confidenceScoreSubtextAboveCopy;
  } else if (
    targetText === IN_CONFIDENCE_ZONE &&
    probabilityOfSuccess <= targetRangeHigh &&
    probabilityOfSuccess >= targetRangeLow
  ) {
    copy = Content.confidenceScoreSubtextTargetCopy;
  } else if (
    targetText === BELOW_CONFIDENCE_ZONE &&
    probabilityOfSuccess < targetRangeLow
  ) {
    copy = Content.confidenceScoreSubtextBelowCopy;
  }

  return (
    <div className="subtext-container">
      <span
        className="subtext"
        dangerouslySetInnerHTML={{ __html: contentConverter.makeHtml(copy) }}
      />
    </div>
  );
};

const ConfidenceScoreCard = ({
  isCustomerWebView,
  received,
  targetText,
  targets
}) => {
  return (
    <BaseCard
      title={Content.confidenceScoreHeader}
      footer={<ConfidenceScoreModal />}
      isLoading={false}
      className="standard confidence-score-card-container">
      {received && (
        <p className="likelihood-text">
          This is the likelihood of funding all your goals.
        </p>
      )}
      <ConfidenceMeterGroup className="confidence-score-padding" />
      {received && <Subtext targetText={targetText} targets={targets} />}
      <a
        href={planningDetailsUrl(isCustomerWebView)}
        className="ras-home-link">
        View Retirement Advisory Service Home
      </a>
    </BaseCard>
  );
};

const mapStateToProps = (state) => ({
  isCustomerWebView: getCustomerWebView(state),
  received: hasReceivedMonteCarloConfidenceScores(state),
  targetText: getMonteCarloConfidenceScoreTargetText(state),
  targets: getMonteCarloConfidenceScoreTargets(state)
});

export default connect(mapStateToProps)(ConfidenceScoreCard);
